import { useLocale } from '../../preferences/i18n/LocaleProvider';

export function NotesEditor({ value, onChange }: { value: string; onChange: (value: string) => void }) {
	const { t } = useLocale();

	return (
		<label style={{ display: 'grid', gap: 6 }}>
			<span>{t('notes')}</span>
			<textarea className="hud-input" rows={5} value={value} onChange={(event) => onChange(event.target.value)} />
		</label>
	);
}
